/** @class AccountSummary
 *
 * @desc
 * Displays summary information about the client Everplan being viewed.
 *
 * @todo Wire up the following with v2 resources:
 *.   - Deputization status text
 *.   - View Everplan link
 *.   - Statistics
 */
import classnames from 'classnames'
import {List} from 'immutable'
import PropTypes from 'prop-types'

import AddDraftDeputyForClient from './AddDraftDeputyForClient'
import ItemPermissionsContainer from '../../request_item_permissions/ItemPermissionsContainer'
import ShadowWrapper from '../../shared_firm/ShadowWrapper'
import Statistics from './Statistics'
import DeputyInformation from './DeputyInformation'

import {isFuneralHome} from '../../../lib/firmTools'

import './accountSummary.scss'

const AccountSummary = ({
  clientFirstName,
  isClientDeceased,
  isLimitedClient,
  ...otherProps
}) => {
  const isQuarterback = otherProps.currentUser.get('quarterback')

  if (otherProps.anyoneActive) {
    return (
      <div className='account-summary' data-testid='account-summary'>
        <h3>Everplan Summary</h3>
        <ShadowWrapper>
          <ul className='account-summary-list'>
            {
              isQuarterback && !isLimitedClient && !isClientDeceased &&
              <li>
                <AddDraftDeputyForClient
                  clientEverplanId={otherProps.everplanSummary.get('id')}
                  clientFirstName={clientFirstName}
                  clientSeatId={otherProps.data.data.client_seat_id}
                  clientUserId={otherProps.data.data.user_id}
                />
              </li>
            }
            {
              !isQuarterback && !isFuneralHome(otherProps.firm) &&
              <li>
                <DeputyInformation
                  currentUser={otherProps.currentUser}
                  currentUserIsDeputy={otherProps.data.current_user_is_deputy}
                  everplanSummary={otherProps.everplanSummary}
                />
              </li>
            }
            <li
              className={
                classnames({'no-list-style': isFuneralHome(otherProps.firm)})
              }>
              <ItemPermissionsContainer {...otherProps} />
            </li>
          </ul>
          <Statistics
            everplanSummary={otherProps.everplanSummary}
            isLimitedClient={isLimitedClient}
            isQuarterback={isQuarterback}
            itemResponses={otherProps.itemResponses}
          />
        </ShadowWrapper>
      </div>
    )
  } else {
    return null
  }
}

AccountSummary.propTypes = {
  clientFirstName: PropTypes.string,
  isClientDeceased: PropTypes.bool,
  isLimitedClient: PropTypes.bool,
  itemResponses: PropTypes.instanceOf(List)
}

export default AccountSummary
